module.exports = __webpack_public_path__ + "img/banner-14.c68ff719.jpg";